import React from "react";
import "./BoardMembers.css";
import { useVisibilityOnScroll } from "../../../Component/Hooks/useVisibilityOnScroll/useVisibilityOnScroll";
import VisibilitySection from "../../../Component/Hooks/useVisibilityOnScroll/VisibilitySection";
import BMImages from "../../../Component/ReuseComponent/BMImages/BMIamges";
import BMS1Img1 from "../../../Assets/images/BoardMembers/BMS1Img1.webp";
import BMS1Img2 from "../../../Assets/images/BoardMembers/BMS1Img2.webp";
import BMS1Img3 from "../../../Assets/images/BoardMembers/BMS1Img3.webp";
import BMS1Img4 from "../../../Assets/images/BoardMembers/BMS1Img4.webp";
import BMS1Img5 from "../../../Assets/images/BoardMembers/BMS1Img5.webp";
import BMS1Img6 from "../../../Assets/images/BoardMembers/BMS1Img6.webp";
import BMS4Img from "../../../Assets/images/BoardMembers/BoardMembersS4Img.webp";
import BMS4ImgMob from "../../../Assets/images/BoardMembers/BoardMembersS4ImgMob.webp";

import TC3L from "../../../Component/ReuseComponent/TCLines/TC3L";
import ImgBox from "../../../Component/ReuseComponent/ImgBox/ImgBox";
export default function BoardMembersArContent() {
  const { sectionsRef, visibilityStates } = useVisibilityOnScroll();

  return (
    <>
      <div className="BoardMembersContainer">
        <VisibilitySection index={0} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="BoardMembersS1">
          <BoardMembersS1 />
        </VisibilitySection>
        <VisibilitySection index={1} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="BoardMembersS2">
          <BoardMembersS2 />
        </VisibilitySection>
        <VisibilitySection index={2} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="BoardMembersS3">
          <BoardMembersS3 />
        </VisibilitySection>
        <VisibilitySection index={3} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="BoardMembersS4">
          <BoardMembersS4 />
        </VisibilitySection>
      </div>
    </>
  );
}
function BoardMembersS1() {
  return (
    <>
      <div className="BoardMembersS1">
        <div className="BoardMembersS1P1">
          <TC3L
            //  Head="أعضاء مجلس الإدارة"
            Title="تعرف على العقول اللي ورا ميلكيز"
            TitleWidthMob="60vw"
          />
        </div>
        <div className="BoardMembersS1P2">
          <BMImages ImgSrc={BMS1Img1} ImgAlt="" Head="جون كارتر" Title="رئيس مجلس الإدارة" />
          <BMImages ImgSrc={BMS1Img2} ImgAlt="" Head="إميلي رودريجيز" Title="مدير العمليات الرئيسي" />
          <BMImages ImgSrc={BMS1Img3} ImgAlt="" Head="مارك ابراهيم" Title="رئيس الاستدامة" />
        </div>
      </div>
    </>
  );
}
function BoardMembersS2() {
  return (
    <>
      <div className="BoardMembersS2">
        <BMImages ImgSrc={BMS1Img4} ImgAlt="" Head="صوفيا لين" Title="مدير رعاية الحيوان" />
        <BMImages ImgSrc={BMS1Img5} ImgAlt="" Head="مايكل أودونيل" Title="المدير المالي" />
        <BMImages ImgSrc={BMS1Img6} ImgAlt="" Head="مريم احمد" Title="مسؤول التسويق" />
      </div>
    </>
  );
}
function BoardMembersS3() {
  return (
    <>
      <div className="BoardMembersS3">
        <div className="BMS3P1">
          <TC3L
            // Head="اعرف أكتر عن مزارعينا"
            Title={<>بنحتفل بقلب وروح مزرعة ميلكي</>}
            TitleWidthMob="90vw"
            Para="ورا كل كوب حليب في تفاني مزارعينا اللي بيشتغلوا بكل إخلاص عشان يضمنوا أعلى جودة لعيلتك، مع التزامهم بممارسات مستدامة وأخلاقية. مزرعة ميلكي فخورة بفريقها اللي بيهتم بالأرض والحيوانات والمجتمع بشغف وحب حقيقي"
            ParaWidth="56vw"
            ParaWidthMob="90vw"
          />
        </div>
      </div>
    </>
  );
}
function BoardMembersS4() {
  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <div className="BoardMembersS4">
        <ImgBox ImgSrc={isMobile ? BMS4ImgMob : BMS4Img} ImgAlt="" />
      </div>
    </>
  );
}
